import { Star, Quote } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { TESTIMONIALS } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-[#0B132B] py-16 md:py-24"
    >
      <div className="mx-auto max-w-6xl px-5 md:px-8">
        <div className="mb-14 text-center">
          <Reveal>
            <span className="font-label text-xs text-primary">
              From the Regulars
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display text-5xl md:text-7xl text-[#F8F5F2]">
              Loved by Bellevue.
            </h2>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <Carousel
            opts={{ align: "start", loop: true }}
            className="px-2 md:px-12"
            data-testid="testimonials-carousel"
          >
            <CarouselContent>
              {TESTIMONIALS.map((t, i) => (
                <CarouselItem key={i} className="md:basis-1/2">
                  <div className="h-full rounded-md border border-white/10 bg-[#1C2541] p-8 md:p-10 flex flex-col">
                    <Quote className="h-9 w-9 text-primary/60" />
                    <div className="mt-4 flex gap-1">
                      {Array.from({ length: 5 }).map((_, s) => (
                        <Star
                          key={s}
                          className="h-4 w-4 fill-primary text-primary"
                        />
                      ))}
                    </div>
                    <p className="mt-5 text-lg text-[#F8F5F2]/90 leading-relaxed flex-1">
                      "{t.quote}"
                    </p>
                    <div className="mt-7 pt-5 border-t border-white/10">
                      <p className="font-display text-xl text-[#F8F5F2]">
                        {t.name}
                      </p>
                      <p className="font-label text-[11px] text-primary mt-1">
                        {t.role}
                      </p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious
              data-testid="testimonial-prev"
              className="text-[#F8F5F2] border-white/20 bg-[#1C2541] hover:bg-primary hover:text-primary-foreground"
            />
            <CarouselNext
              data-testid="testimonial-next"
              className="text-[#F8F5F2] border-white/20 bg-[#1C2541] hover:bg-primary hover:text-primary-foreground"
            />
          </Carousel>
        </Reveal>
      </div>
    </section>
  );
}
